// Must be done so that TypeScript knows that there is a global dataLayer object
declare const window: Window & { [key: string]: any }

/**
 * Add an event to the dataLayer, which Google Tag Manager uses to track events.
 * 
 * @param event The name of the event
 * @param data The data to send with the event
 */
export const addToDataLayer = (event: string, data: any = null) => {
    window.dataLayer = window.dataLayer || [];
    
    const ecommerceEvents = ['view_item_list', 'view_item', 'select_item', 'checkout_begin', 'add_payment_info', 'add_shipping_info', 'purchase'];

    let eventObject = {
        'event': event,
    };
    
    if (data !== null) {
        eventObject = {
            ...eventObject,
            ...data
        };
    }
    
    if (ecommerceEvents.includes(event)) {
        window.dataLayer.push({ ecommerce: null });
    }
    
    window.dataLayer.push(eventObject);
}

export const gtag = (...args: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({...args});
}